import { useMutation } from '@tanstack/react-query';

type CompanyFilePostRequest = {
  companyId: number;
  file: File;
};

export default function usePostCompanyFile() {
  const token = (document.getElementsByName('csrf-token')[0] as HTMLMetaElement).content;
  return useMutation({
    mutationFn: async ({ companyId, file }: CompanyFilePostRequest) => {
      const formData = new FormData();
      formData.append('file', file);

      const response = await fetch(`/agent/api/companies/${companyId}/files`, {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'X-CSRF-Token': token,
        },
        body: formData,
      });
      const data = await response.json();
      return data;
    },
  });
}
